























import url from 'url';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { getIsPortalEnabledStatus } from '@/appsync/service/SystemSettingQueryService';
import AppBar, { AppBarLiteralTexts } from '@/containers/globals/AppBar.vue';
import { i18n } from '@/plugins/i18n/i18n';
import router from '@/router';
import { authLogout } from '@/router/authenticate';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import { RouterItem, UserInfo, LoginInfo } from '@/types/type';
import { _BooleanEnum2boolean, getUserManualUrl } from '@/utils/CommonUtils';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component({
  components: { AppBar },
})
export default class PortalAppBar extends Vue {
  @Prop()
  private loading!: boolean;

  @Prop()
  private userInfo!: UserInfo;

  @Prop()
  private loginInfo!: LoginInfo;

  private isPortalEnabled: boolean = false;

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    this.isPortalEnabled = await getIsPortalEnabledStatus(
      loginInfo.tenant,
      loginInfo.landscape
    );
  }

  private get appMenus(): RouterItem[] {
    const appMenus: RouterItem[] = [];
    if (this.isPortalEnabled) {
      appMenus.push(
        {
          id: '10',
          icon: 'mdi-home',
          title: i18n.tc('sidemenu.home'),
          path: '/',
        },
        {
          id: '20',
          icon: 'mdi-link-box-variant-outline',
          title: i18n.tc('common.menu'),
          path: PAGE_PATH_BY_NAME.sitemap,
        }
      );
    }

    appMenus.push(
      {
        id: '40',
        icon: 'mdi-clock-time-four-outline',
        title: i18n.tc('jobScheduler.common.scheduler'),
        path: PAGE_PATH_BY_NAME.eventCalendarForMonth,
      },
      {
        id: '50',
        icon: 'mdi-file-refresh-outline',
        title: i18n.tc('jobScheduler.jobs.title'),
        path: PAGE_PATH_BY_NAME.jobs,
      },
      {
        id: '999',
        icon: 'mdi-application-cog-outline',
        title: i18n.tc('common.commonSetting'),
        path: PAGE_PATH_BY_NAME.commonsettingGeneral,
      }
    );

    return appMenus;
  }

  private get literalTexts(): AppBarLiteralTexts {
    const loading = this.loading;
    return {
      placeHolder: loading ? '' : i18n.tc('appbar.placeholder'),
      searchMessage: loading ? '' : i18n.tc('appbar.searchMessage'),
      setting: loading ? '' : i18n.tc('appbar.setting'),
      logout: loading ? '' : i18n.tc('appbar.logout'),
      version: i18n.tc('appbar.version'),
      about: this.isPortalEnabled
        ? i18n.tc('appbar.aboutPortal')
        : i18n.tc('appbar.aboutFbs'),
      copyright: this.isPortalEnabled
        ? i18n.tc('appbar.portalCopyright')
        : i18n.tc('appbar.fbsCopyright'),
      ossLicense: i18n.tc('appbar.ossLicense'),
    };
  }

  private goToSearchPage() {
    router.push(PAGE_PATH_BY_NAME.search);
  }

  private openSetting() {
    router.push(PAGE_PATH_BY_NAME.setting);
  }

  private async logout() {
    const cognitoInfo = commonModule.cognitoInfo;
    if (!cognitoInfo) {
      throw new Error('Logout failed due to missing cognitoInfo');
    }
    commonModule.clear();
    loginUserModule.clear();
    await authLogout();
  }

  private goToUserManualTopPage() {
    window.open(getUserManualUrl(), '_blank');
  }
}
